module.exports = __webpack_public_path__ + "img/tradegate_logo.328bc4f0.png";